export default "__VITE_ASSET__Dhme7CgX__"